<template>
  <div>
    <custom-actions :title="`货权审批(${resState === '2' ? '发起方' : '接收方'})`">
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
               label-width="100px">
        <el-form-item label="客户名称" prop="userName">
          <!-- <el-select clearable filterable v-model="searchForm.userId" placeholder="请选择客户名称">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select> -->
          <el-input clearable v-model="searchForm.userName" placeholder="请输入客户名称" />
        </el-form-item>
        <el-form-item label="合同编号" prop="contractNo">
          <el-input clearable v-model="searchForm.contractNo" placeholder="请输入合同编号" />
        </el-form-item>
        <el-form-item label="订单编号" prop="orderNumber">
          <el-input clearable v-model='searchForm.orderNumber' placeholder="请输入订单编号" />
        </el-form-item>

        <el-form-item label="商品名称" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="请输入商品名称" />
        </el-form-item>

        <!-- <el-form-item label="订单状态" prop="orderStatus">
          <el-select clearable filterable v-model="searchForm.orderStatus" placeholder="请选择订单状态">
            <el-option v-for="(item, index) of orderStatusList" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="订单日期" prop="dateArr">
          <el-date-picker v-model="dateArr" type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="合同编号" prop="contractNo"></el-table-column>
        <el-table-column min-width="230" label="订单编号" prop="orderNumber">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/deliveryOrder/list?orderId=' + row.orderId)">{{
                row.orderNumber }}</el-button>
            <el-button v-if="row.orderNumber" type="text" @click.stop="handleCopyOrderNo(row.orderNumber)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="提货日期" prop="pickupDate"></el-table-column>
        <el-table-column min-width="220" show-overflow-tooltip label="商品名称" prop="specName"></el-table-column>
        <el-table-column min-width="120" label="锁定单价(元)" prop="lockedPrice"></el-table-column>
        <el-table-column min-width="120" label="锁定数量" prop="orderQuantity"></el-table-column>
        <!-- 审批人核对本次申请数量；历史全量申请未保存数量时按剩余数量展示。 -->
        <el-table-column min-width="120" label="本次转让数量">
          <template v-slot="{ row }">{{ row.resQuantity == null ? row.kyQuantity : row.resQuantity }}</template>
        </el-table-column>
        <el-table-column min-width="120" label="已用数量" prop="usedQuantity"></el-table-column>
        <el-table-column min-width="180" label="提货进行中数量" prop="usedAddQuantity"></el-table-column>
        <el-table-column min-width="120" label="可用数量" prop="kyQuantity"></el-table-column>
        <!-- <el-table-column min-width="120" label="价格差(元)" prop="priceDiff"></el-table-column> -->
        <el-table-column min-width="120" label="保证金比例" prop="orderDeposit">
          <template v-slot="{ row }">
            {{ row.orderDeposit + "%" }}
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="锁定保证金(元)" prop="lockedDeposit"></el-table-column>
        <!-- <el-table-column min-width="180" label="锁定保证金(充值)(元)" prop="lockedDepositDeposit"></el-table-column> -->
        <!-- <el-table-column min-width="180" label="锁定保证金(其他)(元)" prop="lockedPickupDeposit"></el-table-column> -->
        <el-table-column min-width="120" label="订单状态" prop="orderStatus">
          <template v-slot="{ row }">
            <template v-if="row.resState !== '1'">
              <el-tag type="warning">货转中</el-tag>
            </template>
            <template v-else>
              <el-tag type="warning" v-if="row.orderStatus == '1'">待审批</el-tag>
              <el-tag type="primary" v-if="row.orderStatus == '2'">进行中</el-tag>
              <el-tag type="success" v-if="row.orderStatus == '3'">已完成</el-tag>
              <el-tag type="danger" v-if="row.orderStatus == '4'">驳回作废</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="190" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/orderManage/detail?orderId=' + row.orderId)">详情</el-button>
            <el-button type="text" @click="onAppoval(row)">审批</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 审批 -->
    <ApprovalDialog urlType="6" :relatedId="rowId" v-if='showDlg' @closeDlg="showDlg = false" @successSave="loadData"
                    :showDlg="showDlg"></ApprovalDialog>

    <!-- 提货日期修改 -->
    <EditDateDlg v-if="showDateDlg" :pickupDate="pickupDate" @successSave="loadData" :orderId="rowId"
                 :showDlg.sync="showDateDlg"></EditDateDlg>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'
import BigNumber from 'bignumber.js'
import EditDateDlg from './EditDateDlg.vue'
import { validNumber3 } from '@/utils/validator'
import { copyText } from '@/utils/utils'

export default {
  name: 'GoodsTransfer',
  mixins: [keepAlive],
  components: { ApprovalDialog, EditDateDlg },
  data() {
    return {
      settingVisible: false,
      settingVisible2: false,
      timeArr: ['', ''],
      settingForm: {
        yxStatus: '',
        yxTime: ''
      },
      settingRules: {
        yxStatus: [{ required: true, message: '请选择点价状态' }],
        yxTime: [{ required: true, message: '请选择点价时间断' }]
      },
      settingForm2: {
        numId: '', // id
        orderMinNum: '', // 最小数量
        orderMaxNum: '', // 最大数量
        pickupMaxNum: '', // 最大提货量
        isBulkOil: '' // 粮油规格
      },
      settingRules2: {
        numId: [{ required: true, message: '请选择类型' }],
        orderMinNum: [{ required: true, message: '请输入最小数量' }],
        orderMaxNum: [{ required: true, message: '请输入最大数量' }],
        pickupMaxNum: [{ required: true, message: '请输入最大提货量' }]
      },
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userId: '',
        contractNo: '',
        userName: '',
        orderStatus: '',
        orderNumber: '',
        specName: ''
      },
      editStatusVisible: false,
      editStatusForm: {
        orderId: '',
        orderStatus: ''
      },
      editStatusRules: {
        orderStatus: [{ required: true, message: '请选择释放类型' }]
      },
      dateArr: [],
      userList: [],
      showDlg: false,
      rowId: '',
      showDateDlg: false,
      pickupDate: '',
      transferVisible: false,
      transferForm: {
        orderId: '',
        resUserId: '',
        resPrice: '',
        fileList: []
      },
      transferRules: {
        resUserId: [{ required: true, message: '请选择接收用户' }],
        resPrice: [
          { required: true, message: '请输入接收单价' },
          { pattern: validNumber3, message: '接收单价保留三位小数' }
        ]
      }
    }
  },
  computed: {
    resState() {
      return this.$route.query.resState || ''
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    }
  },
  watch: {
    resState() {
      this.$nextTick(() => {
        this.onReset()
        this.onSearch()
      })
    }
  },
  created() {
    this.loadUserList()
    this.loadData()
  },
  methods: {
    async handleCopyOrderNo(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    onTransfer(row) {
      this.transferForm.orderId = row.orderId
      this.transferVisible = true
      this.$nextTick(() => {
        this.$refs.transferForm.resetFields()
      })
    },
    saveEditStatus() {
      this.$refs.editStatusForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.orderManage.endYxPriceOrderDate, this.editStatusForm).then(res => {
            this.editStatusVisible = false
            this.loadData()
          })
        }
      })
    },
    onAppoval(row) {
      this.rowId = row.orderId
      this.showDlg = true
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '3' }).then(res => {
        this.userList = res.list || []
      })
    },
    loadData() {
      const params = {
        page: this.page,
        resState: this.resState,
        ...this.searchForm
      }
      console.log('params', params)
      if (this.dateArr && this.dateArr.length > 0) {
        params.startDate = this.dateArr[0]
        params.endDate = this.dateArr[1]
      } else {
        params.startDate = undefined
        params.endDate = undefined
      }
      this.$axios
        .get(this.$apis.orderManage.selectYxPriceOrderByPage, {
          params: params
        })
        .then(res => {
          res.list.forEach(item => {
            const orderQuantity = new BigNumber(item.orderQuantity || 0)
            const usedQuantity = new BigNumber(item.usedQuantity || 0)
            const num = orderQuantity.minus(usedQuantity)
            item.kyQuantity = Number(num.toFixed(3))
          })
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.dateArr = []
      this.$refs.formData.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="scss">
.setting-content {
  padding: 20px;
}
</style>
